import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App" // This now correctly imports App.tsx

// A deployment can remove chunks still referenced by an open tab. Refresh once
// per entry bundle, while allowing persistent failures to surface normally.
window.addEventListener("vite:preloadError", (event) => {
  if (!navigator.onLine) return
  try {
    const key = "timebanken:chunk-reload"
    if (sessionStorage.getItem(key) === import.meta.url) return
    sessionStorage.setItem(key, import.meta.url)
  } catch {
    // Without session storage we cannot guarantee protection from reload loops.
    return
  }
  event.preventDefault()
  window.location.reload()
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
